import styled from "styled-components";
import { HeadLine1 } from "../../../../../components/typography/styled";

export const Container = styled.div`
  display:flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  margin: 20px 10px 20px 0px;
  width: 100%;
`
export const CreateContainer = styled.div`
  justify-content: space-between;
  display: inline-flex;
  align-items: flex-start;
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  margin-top: 20px;
  margin-bottom: 20px;
`
